import React, { memo } from 'react';
import { StepIndicator, StepProgress } from './styles';
export var ProgressBar = function ProgressBar(_ref) {
  var current = _ref.current,
      max = _ref.max,
      description = _ref.description,
      dataTest = _ref['data-test'];
  return /*#__PURE__*/React.createElement(StepProgress, {
    current: current + 1,
    max: max,
    text: description,
    "data-test": dataTest
  }, Array(max).fill(undefined).map(function (_, index) {
    return /*#__PURE__*/React.createElement(StepIndicator, {
      key: index,
      isActive: index === current
    });
  }));
};
ProgressBar.displayName = 'ProgressBar';
export default /*#__PURE__*/memo(ProgressBar);